import { fromJS } from 'immutable';
import { createSelector } from 'reselect';

import * as utils from '../utils/duckHelpers';

export const types = {
    ...utils.requestTypes('UNCHECKED_BY_CATEGORY_COUNT'),
    UNCHECKED_BY_CATEGORY_COUNT_RESET: 'UNCHECKED_BY_CATEGORY_COUNT_RESET',
    UNCHECKED_BY_CATEGORY_COUNT_SET: 'UNCHECKED_BY_CATEGORY_COUNT_SET',
    UNCHECKED_BY_CATEGORY_COUNT_GET: 'UNCHECKED_BY_CATEGORY_COUNT_GET',
    UNCHECKED_BY_CATEGORY_COUNT_SUCCESS: 'UNCHECKED_BY_CATEGORY_COUNT_SUCCESS',
};

export const actions = {
    unchecked_by_category_countSet: (obj) => utils.action(types.UNCHECKED_BY_CATEGORY_COUNT_SET, obj),
};

const initialState = fromJS({
    unchecked_by_category_count: null,
    disaster_recovery_count: null,
    technology_count: null,
    highlighted_count: null,
    loaded: 'loading',
});

export default (state = initialState, action) => {
    switch (action.type) {
    case types.UNCHECKED_BY_CATEGORY_COUNT_SET:
        if (action.payload.alerts_by_category_count !== null) {
            const _state = state ? state.toJS() : [];

            return fromJS({
                unchecked_by_category_count: _state.alerts_by_category_count,
                disaster_recovery_count: _state.disaster_recovery_count,
                technology_count: _state.technology_count,
                highlighted_count: _state.highlighted_count,
                loaded: 'complete',
            });
        }

        break;
    case 'disaster_recovery_count':
        if (action.payload.alerts_by_category_count !== null) {
            const _state = state ? state.toJS() : [];

            return fromJS({
                unchecked_by_category_count: _state.alerts_by_category_count,
                disaster_recovery_count: action.payload.alerts_by_category_count,
                technology_count: _state.technology_count,
                highlighted_count: _state.highlighted_count,
                loaded: 'complete',
            });
        }

        break;
    case 'technology_count':
        if (action.payload.alerts_by_category_count !== null) {
            const _state = state ? state.toJS() : [];
            return fromJS({
                unchecked_by_category_count: _state.alerts_by_category_count,
                technology_count: action.payload.alerts_by_category_count,
                disaster_recovery_count: _state.disaster_recovery_count,
                highlighted_count: _state.highlighted_count,
                loaded: 'complete',
            });
        }

        break;
    case 'highlighted_count': {
        if (action.payload.alerts_by_category_count !== null) {
            const _state = state ? state.toJS() : [];
            return fromJS({
                unchecked_by_category_count: _state.alerts_by_category_count,
                highlighted_count: action.payload.alerts_by_category_count,
                disaster_recovery_count: _state.disaster_recovery_count,
                technology_count: _state.technology_count,
                loaded: 'complete',
            });
        }

        const _state = state ? state.toJS() : [];
        return fromJS({
            unchecked_by_category_count: _state.alerts_by_category_count,
            highlighted_count: _state.highlighted_count,
            disaster_recovery_count: _state.disaster_recovery_count,
            technology_count: _state.technology_count,
            loaded: _state.loaded ? 'complete' : 'empty',
        });
    }

    case types.UNCHECKED_BY_CATEGORY_COUNT_RESET:
        return initialState;

    default:
        return state;
    }
};

 
const getUnchecked_by_category_count = (state) => state.get('app').get('unchecked_by_category_count');

export const selectors = {
    getUnchecked_by_category_count: getUnchecked_by_category_count,
};
